import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";

import "./index.css";
import { queryClient, router } from "./contexts";
import { ErrorBoundary } from "@/components/error-boundary";
import { Toaster } from "@/components/ui/sonner";

const sentryDsn = __VITE_SENTRY_DSN__;
if (sentryDsn) {
  const environment = __ENVIRONMENT__;
  Sentry.init({
    dsn: sentryDsn,
    environment,
    sendDefaultPii: false,
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Browser performance tracing. Propagates sentry-trace/baggage headers to
    // the API so frontend transactions link to the backend's HTTP transaction
    // and service spans (one end-to-end trace).
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    // Only attach trace headers to our own API (matches the /api/v1 path in
    // both relative and absolute request URLs). Avoids leaking headers to
    // third parties (Supabase/Dodo).
    tracePropagationTargets: [/\/api\/v1\//],
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </ErrorBoundary>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
